/**
 * Client-side capture of source context for lead submissions.
 * Server also stamps IP + User-Agent. The client fields are informational.
 */
export function captureSourceContext(): {
  source_page: string;
  source_url: string;
  referrer: string | null;
  landing_page: string | null;
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  utm_term: string | null;
  utm_content: string | null;
} {
  if (typeof window === "undefined") {
    return {
      source_page: "",
      source_url: "",
      referrer: null,
      landing_page: null,
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_term: null,
      utm_content: null,
    };
  }
  const url = window.location.href;
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);
  const get = (k: string) => params.get(k);

  // Landing page persisted per-visit in sessionStorage.
  let landing: string | null = null;
  try {
    landing = window.sessionStorage.getItem("mah_landing") ?? null;
    if (!landing) {
      landing = url;
      window.sessionStorage.setItem("mah_landing", landing);
    }
  } catch {
    // storage disabled — ignore
  }

  return {
    source_page: path,
    source_url: url,
    referrer: document.referrer || null,
    landing_page: landing,
    utm_source: get("utm_source"),
    utm_medium: get("utm_medium"),
    utm_campaign: get("utm_campaign"),
    utm_term: get("utm_term"),
    utm_content: get("utm_content"),
  };
}
